function hasEmpresaPermission(store, permiso) {
  const permisos = store.state.auth.permisos;
  if (permisos === '__all__') return true;
  if (!Array.isArray(permisos)) return false;
  return permisos.includes(permiso);
}

// Una ruta puede pedir un permiso (`meta.permiso`) o cualquiera de varios
// (`meta.permisos`). Sin permisos declarados no restringe.
function tieneAlgunPermiso(store, meta) {
  const requeridos = meta.permisos || (meta.permiso ? [meta.permiso] : []);
  if (!requeridos.length) return true;
  return requeridos.some(permiso => hasEmpresaPermission(store, permiso));
}

// Módulos que se activan/desactivan por plan contratado (independiente del rol).
// Si no hay suscripción cargada o no está vigente, no restringe (mismo criterio que el sidebar).
function hasModuloContratado(store, codigo) {
  const suscripcion = store.state.auth.suscripcion;
  if (!suscripcion || !suscripcion.vigente || !suscripcion.modulos || !suscripcion.modulos.length) return true;
  return store.getters['auth/tieneModulo'](codigo);
}

export async function checkRoleAccess({ store, to }) {
  const { user, isLogged } = store.state.auth;
  if (!isLogged) return null;

  const role = user.role || [];
  const isAdmin = role.includes('admin');
  const isOwner = role.includes('owner');
  const isEmployee = role.includes('employee');
  
  const context = to.matched.find(r => r.meta.context)?.meta.context || null;
  const meta = to.matched.reduce((acc, r) => ({ ...acc, ...r.meta }), {});

  // --- ContextO ADMIN ---
  if (context === 'admin' && !isAdmin) {
    return isEmployee ? { name: 'pos.dashboard' } : { path: '/' };
  }

  // --- CONTEXTO EMPRESA (Toda tu lógica original está aquí) ---
  if (context === 'empresa') {
    // Gating por plan contratado: aplica a todos los roles, incluso admin/owner,
    // porque depende de la suscripción de la empresa, no del permiso del usuario.
    if (meta.modulo === 'sueldos' && !hasModuloContratado(store, 'sueldos')) {
      return { name: 'empresa.dashboard' };
    }

    if (isAdmin || isOwner) return null; // Acceso total

    // Empleado de PRODUCCIÓN: solo accede al módulo de producción.
    // Cualquier otra ruta lo lleva a su cola de trabajo (no al POS).
    if (role.includes('produccion')) {
      return meta.modulo === 'produccion' ? null : { name: 'empresa.produccion.cola' };
    }

    // Lógica específica para empleados y productos
    if (isEmployee && meta.modulo === 'productos' && (meta.permiso || meta.permisos)) {
      if (tieneAlgunPermiso(store, meta)) return null;
    }

    return { name: 'pos.dashboard' };
  }

  // --- CONTEXTO POS ---
  // Los empleados operan aca, asi que el gating es por permiso de la asignacion
  // en la sucursal (ej: 'realizar_inventario'). Owner/admin pasan por '__all__'.
  if (context === 'pos' && !tieneAlgunPermiso(store, meta)) {
    return { name: 'pos.dashboard' };
  }

  return null;
}